(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3ScorePosting', {
            templateUrl: 'app/shared/score-posting/score-posting.component.html',
            controller: ScorePostingComponent,
            bindings: {
                data: '<',
                onPosted: '&'
            }
        });

    var noop = angular.noop;

    ScorePostingComponent.$inject = ['$scope', '$state', 'Score', 'shared_resources', 'alert', 'signInManager', 'statusCodes', 'ScoreDto', 'confirm'];
    function ScorePostingComponent($scope, $state, Score, resources, alert, signInManager, statusCodes, ScoreDto, confirm) {
        var ctrl = this;
        Object.defineProperty(ctrl, 'score', { get: getScore, set: setScore });
        Object.defineProperty(ctrl, 'facility', { get: getFacility });
        Object.defineProperty(ctrl, 'teeTime', { get: getTeeTime });
        Object.defineProperty(ctrl, 'entryType', { get: getEntryType, set: setEntryType });

        ctrl.$onInit = init;
        ctrl.submit = submit;
        ctrl.getButtonClass = getButtonClass;
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });
        $scope.$watch('$ctrl.score.isHoleByHole', isHoleByHoleWatchAction);

        //////////////////////////////////

        function init() {
            var data = ctrl.data,
                score = data.score,
                teeTime = data.teeTime;

            data.score = new ScoreDto(score);
            if (teeTime) ctrl.entryType = 'NoScore';
        }

        function submit() {
            if (ctrl.form.$valid) {      

                var temp = ctrl.facility;
                var tempScore = ctrl.score;
                
                var holesPlayed = 0;                 
                if (tempScore.holesPlayed === "EighteenHoles" && tempScore.isHoleByHole) {

                    var holes = tempScore.holeScores;
                    for (var i = 0; i < 22; i++) {
                        if (holes[i].number >= 1 && holes[i].number <= 18 && holes[i].number % 1 === 0 && holes[i].esc > 0)
                            holesPlayed++;
                    }
                }
                else {
                    holesPlayed = tempScore.holesPlayed === "EighteenHoles" ? 18 : 9;
                }
                    

                if (tempScore.holesPlayed === "EighteenHoles" && tempScore.esc < tempScore.$$adjTargetScore && holesPlayed == 18)
                    confirm(resources.lowScoreWarningConfirmation).then(postScore, noop);
                else
                    postScore();
            }

            function postScore() {
                Score.postScore(ctrl.score, true).$promise
                    .then(setPristine)
                    .then(refreshUser)
                    .then(fireEvent)
                    .catch(showError);
            }

            function setPristine(newScore) {
                ctrl.data.score = new ScoreDto(newScore);
                ctrl.form.$setPristine();
            }

            function refreshUser(newScore) {
                return signInManager.refresh().catch(noop);
            }

            function fireEvent() {
                ctrl.onPosted(ctrl.score);
            }

            function showError(response) {
                var status = response.status,
                    serverMessage = response.data.message,
                    showServerMessage = serverMessage && status === statusCodes.badRequest,
                    message = showServerMessage ? serverMessage : resources.postScoreError;

                alert.error(message);
            }
        }
        function getButtonClass() {
            return ctrl.form.$pristine || ctrl.form.$invalid ? 'btn-default' : 'btn-canada';
        }
        function isHoleByHoleWatchAction(newVal, oldVal) {
            if (newVal != oldVal)
                ctrl.form.$setDirty();
        }

        function getScore() {
            return ctrl.data.score;
        }

        function setScore(value) {
            ctrl.data.score = value;
        }

        function getFacility() {
            return ctrl.data.facility;
        }

        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }

        function getTeeTime() {
            return ctrl.data.teeTime;
        }

        function getEntryType() {
            return ctrl.score.isNoScore ? 'NoScore' : ctrl.score.isHoleByHole ? 'HoleByHole' : 'Total';
        }
        function setEntryType(value) {
            switch (value) {
                case "NoScore":
                    ctrl.score.isNoScore = true;
                    ctrl.score.isHoleByHole = false;
                    break;
                case "HoleByHole":
                    ctrl.score.isNoScore = false;
                    ctrl.score.isHoleByHole = true;
                    break;
                case "Total":
                    ctrl.score.isNoScore = false;
                    ctrl.score.isHoleByHole = false;
                    break;
            }
        }

    }
})();